import {Component, OnInit, Input, ViewChild} from '@angular/core';
import { NoteCategoryEnum } from 'src/app/models/enum/note-category.enum';
import { NoteTypeEnum } from 'src/app/models/enum/note-type.enum';
import { FormsService } from '../../forms/forms.service';
import { InsuranceService } from '../../insurance/insurance.service';
import {TdoSimpleNoteComponent} from '../../../tdo-controls/common/tdo-simple-note/tdo-simple-note.component';

@Component({
    selector: 'app-patient-insurance-card',
    templateUrl: './patient-insurance-card.component.html',
    styleUrls: ['./patient-insurance-card.component.css']
})
export class PatientInsuranceCardComponent implements OnInit {

    @Input() patientId: string;
    @Input() data: any[];

    @ViewChild('simpleNote') simpleNote: TdoSimpleNoteComponent;

    formNotFound: boolean = false;
    isLoading: boolean = true;
    activeOrganizationId: string;
    activeInsuranceCard: string;
    dataInsurances: any[];

    readonly NoteCategoryEnum = NoteCategoryEnum;
    readonly NoteTypeEnum = NoteTypeEnum;

    constructor(
        private formsService: FormsService,
        private insuranceService: InsuranceService,
    ) { }

    ngOnInit() {
        this.isLoading = true;
    /* this.getPatientInsurances()
      .then((result: any) => {
        console.log("getPatientInsurances", result);
        if (!result || !result.dataPatientInsurances) {
          this.dataInsurances = [];
          return;
        }

        result.dataPatientInsurances = result.dataPatientInsurances.sort((a, b) => { return a.InsuranceOrder - b.InsuranceOrder });
        this.dataInsurances = result.dataPatientInsurances.map(dataPatientInsurance => { return dataPatientInsurance.dataInsurance });
        this.isLoading = false;

        console.log("datainsurances", this.dataInsurances);

        if (this.dataInsurances.length && this.dataInsurances.length >= 1) {
          this.activeOrganizationId = this.dataInsurances[0].OrganizationID;
          this.getPatientInsuranceCard(this.dataInsurances[0].OrganizationID)
            .then((insuranceCardID: any) => {
              this.formNotFound = false;
              this.activeInsuranceCard = insuranceCardID;
            }, err => {
              console.log(err);
              this.formNotFound = true;
            });
        }

      }, err => {
        this.isLoading = false;
        console.log(err);
      });*/
    }

    /* getPatientInsurances() {
    let promise = new Promise((resolve, reject) => {
      this.insuranceService.getPatientInsuranceInformation(this.patientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }*/

    /* getPatientInsuranceCard(organizationID: string) {
    console.log("PatientInsuranceCardComponent getPatientInsuranceCard", organizationID);

    let promise = new Promise((resolve, reject) => {
      this.formsService.getInsuranceCardFormID(organizationID, this.patientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }*/

    /* insuranceSelected(organizationID) {
    this.isLoading = true;
    this.getPatientInsuranceCard(organizationID)
      .then((insuranceCardID: any) => {
        this.activeInsuranceCard = insuranceCardID;
        this.isLoading = false;
        this.formNotFound = false;
      }, err => {
        this.isLoading = false;
        this.formNotFound = true;
        console.log(err);
      });
  }*/



}
